<script setup>
import { computed } from 'vue'

const props = defineProps({
  row: { type: Object, required: true },
  rows: { type: Array, default: () => [] },
  formatTime: { type: Function, required: true },
})
const merged = computed(() => (props.row.bet_ids?.length || 0) > 1)
const orderId = computed(() => {
  const value = String(props.row.bet_ids?.[0] ?? props.row.bet_id ?? '')
  return /^[1-9]\d*$/.test(value) ? value : ''
})
const sameSecond = computed(() => {
  const second = Number(props.row.bet_create_time)
  if (!Number.isFinite(second) || second <= 0) return false
  return merged.value || props.rows.filter(row => Number(row.bet_create_time) === second).length > 1
})
const suffix = computed(() => sameSecond.value && orderId.value ? `.${orderId.value}` : '')
</script>

<template>
  <span class="bet-detail-time">
    <time>[{{ formatTime(row.bet_create_time) }}{{ suffix }}]</time>
    <small v-if="suffix">点号后为{{ merged ? '首笔' : '' }}订单编号，非毫秒</small>
  </span>
</template>

<style scoped>
.bet-detail-time{flex:0 1 auto;min-width:0;text-align:right;white-space:normal!important;overflow:visible!important}
.bet-detail-time time{overflow-wrap:anywhere;white-space:normal}
.bet-detail-time small{display:block;font-size:10px;line-height:1.4;white-space:normal}
</style>
